module.exports = __webpack_public_path__ + "img/clock1.1089df0d.svg";